module.exports = __webpack_public_path__ + "static/exchange_add_calendar_3-042822fb67356319fb14da054d442217.png";